import React from 'react';
import { Note, isNatural } from '../models/Note';

interface PianoProps {
  selectedNotes: Note[];
  toggleSelection: (note: Note) => void;
}

const keys: string[] = ['C', '', 'D', '', 'E', 'F', '', 'G', '', 'A', '', 'B'];

export const Piano: React.FunctionComponent<PianoProps> = props => (
  <div className="piano">
    {keys.map((key: string, note: Note) => (
      <div key={note} className="key-wrapper">
        <div
          key={key}
          data-testid={'key-' + note}
          className={
            'key' +
            (isNatural(note) ? ' white' : ' black') +
            (props.selectedNotes.includes(note) ? ' selected' : '')
          }
          onClick={() => props.toggleSelection(note)}
        >
          <div>{key}</div>
        </div>
      </div>
    ))}
  </div>
);
